import { DestroyRef, Directive, EventEmitter, inject, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Checklist, TerminateDepotFacade } from '@zero/self-service/domain';
import { Step } from '../enums/step';

@Directive()
export abstract class TerminateDepotBase {
  @Output() public logout = new EventEmitter<void>();

  public readonly Step = Step;
  public currentStep = Step.HINT;
  public reason = '';
  public currentChecklist: Checklist;

  readonly #destroyRef = inject(DestroyRef);
  public readonly terminateDepotFacade = inject(TerminateDepotFacade);

  public abstract start(): void;
  public abstract close(): void;

  public terminate(): void {
    this.terminateDepotFacade.terminate(this.reason);
    this.terminateDepotFacade.authSuccess$
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe((success: boolean) => success && this.#checkStatus());
  }

  public next(): void {
    this.currentStep++;
  }

  #checkStatus = (): void => {
    this.terminateDepotFacade.checkStatus();
    this.terminateDepotFacade.terminationDone$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((done: boolean) => done && this.next());
  };
}
